import {
  Configuration,
  LogLevel,
} from '@azure/msal-browser';
import { MICROSOFT_CLIENT_ID } from '../api/apiConfig';

const clientId = MICROSOFT_CLIENT_ID;

if (!clientId) {
  throw new Error(
    'REACT_APP_MICROSOFT_CLIENT_ID is not configured.'
  );
}

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: `${window.location.origin}/login`,
    postLogoutRedirectUri: `${window.location.origin}/login`,
  },

  cache: {
    cacheLocation: 'sessionStorage',
  },

  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }

        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;

          case LogLevel.Warning:
            console.warn(message);
            break;

          default:
            break;
        }
      },
    },
  },
};

export const microsoftLoginRequest = {
  scopes: [
    'openid',
    'profile',
    'email',
  ],

  prompt: 'select_account',
};